import Axios from 'axios'

import { XsrfResilient } from '@/services/Helpers'

import {
    standardizeOrderComplete,
    MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing,
} from '@/services/Standardizers'

import { log } from '@/services/Log'

import { generateLineItemsFromCheckout } from '@/services/FramedCheckout/orderServices'

export const getOrderWithPayments = XsrfResilient(async ({ orderId }) => {
    log('getOrderWithPayments for ', orderId)
    const include = [
        'payments',
        'lineItems.physicalItems.socialMedia',
        'lineItems.physicalItems.options',
        'lineItems.digitalItems.socialMedia',
        'lineItems.digitalItems.options',
    ]
    const options = include?.length ? { params: { include: include.join(',') } } : undefined
    // Returns Order data. - https://developer.bigcommerce.com/api-reference/storefront/orders/order/ordersbyorderidget
    // This will return order data immediately after an order is placed on the storefront.
    const order = (await Axios.get(`/api/storefront/orders/${orderId}`, options)).data
    const lineItems = await generateLineItemsFromCheckout(order)
    lineItems.sort((a, b) => a.sku > b.sku && 1 || -1)
    const newOrder = standardizeOrderComplete(order, lineItems)
    await MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing({ order: newOrder })
    return newOrder
})